// Call directly from the click handler to preserve the browser's user activation.
export async function shareInvitationLink(url, text, navigatorObject = globalThis.navigator) {
  if (typeof navigatorObject?.share !== 'function') return 'unavailable';
  try {
    await navigatorObject.share({ title: 'WordCraft', text, url });
    return 'shared';
  } catch (error) {
    return error?.name === 'AbortError' ? 'cancelled' : 'unavailable';
  }
}
